import {
    CountrySelectorCountry,
    CountrySelectorData,
} from "@hermes/api-model-country";
import { Locale, localeFromUrlPrefixUnsafe } from "@hermes/locale";

/**
 * Get activated locales from country selector data
 */
export const extractActivatedLocalesFromCountrySelectorData = (
    countrySelectorData: CountrySelectorData,
): Locale[] =>
    getLinks(countrySelectorData)
        .map(getLocaleFromLink)
        // remove links that doesn't match a locale
        .filter((locale): locale is Locale => !!locale);

/**
 * Get all country links in country selector
 *
 * @param countryData Country selector's data
 */
const getLinks = (countryData: CountrySelectorData) => {
    const links: string[] = [];
    if (countryData?.areas && countryData.areas.length > 0) {
        for (const area of countryData.areas) {
            links.push(...getCountryLinks(area.areaCountries));
        }
    }
    return links;
};

/**
 * Get countries and sub-countries links (recursive)
 *
 * @param countries List of countries to parse
 */
const getCountryLinks = (countries: CountrySelectorCountry[]): string[] => {
    const links: string[] = [];
    for (const country of countries) {
        links.push(country.countryLink);
    }
    return links;
};

/**
 * Compute locale from link (`/us/en` or `/us/en/` => Locale object)
 *
 * @param link Link to transform into Locale
 */
const getLocaleFromLink = (link: string): Locale | undefined => {
    const linkWithoutTrailingSlash = link.endsWith("/")
        ? link.slice(0, -1)
        : link;
    return localeFromUrlPrefixUnsafe(linkWithoutTrailingSlash);
};
